module.exports = __webpack_public_path__ + "static/js/mailMerges.b80f346e.chunk.worker.js"